import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import {
  ITableSelectionEvent,
  ITableSelectRangeEvent,
  IDataTableAdapter,
} from '@app/shared/interfaces';
import { MatDialog } from '@angular/material/dialog';
import { ModalErrorsDetailsComponent } from '../modal-errors-details/modal-errors-details.component';

@Component({
  selector: 'app-table-errors',
  templateUrl: './table-errors.component.html',
  styleUrls: ['./table-errors.component.sass'],
})
export class TableErrorsComponent implements OnInit {
  columns: Array<any>;
  modalColumns: Array<any>;
  displayedColumns: Array<any>;
  dataSource = new MatTableDataSource<any>([]);
  selection = new SelectionModel<any>(true, []);
  serverPagination: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;

  @Output() tradeReprocess: EventEmitter<any> = new EventEmitter<any>();
  @Output() batchReprocess: EventEmitter<any[]> = new EventEmitter<any[]>();

  @Input() enablePagination = true;
  @Input() enableSelection = true;
  @Input() selectedAllDefault = false;

  @Input() set dataAdapter(value: IDataTableAdapter) {
    this.buildDataAdpater(value);
  }

  @Output() rowChanged: EventEmitter<ITableSelectionEvent> =
    new EventEmitter<ITableSelectionEvent>();
  @Output() rangeChanged: EventEmitter<ITableSelectRangeEvent> =
    new EventEmitter<ITableSelectRangeEvent>();
  @Output() pageChanged = new EventEmitter<any>();

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    if (this.selectedAllDefault) {
      this.masterToggle();
    }
  }

  buildDataAdpater(value: IDataTableAdapter) {
    this.columns = value.columns
      .filter((c) => c.show)
      .map((column: { key: string | number; label: string; ellipsis?: number }) => ({
        columnDef: column.key,
        header: column.label,
        ellipsis: column.ellipsis,
        cell: (element: any) => `${element[column.key] ? element[column.key] : ``}`,
      }));
    this.modalColumns = value.columns;
    this.displayedColumns = this.columns.map((c) => c.columnDef);

    if (value.enableSelection) {
      this.enableSelection = value.enableSelection;
      this.displayedColumns.unshift('select');
    }

    if (value.enableAction) {
      this.enableSelection = value.enableAction;
      this.displayedColumns.push('action');
    }

    // Set the dataSource for <mat-table>.
    this.dataSource = new MatTableDataSource(value.dataSource);
    this.serverPagination = value.pagination;
  }

  isAllSelected() {
    const numRows = this.dataSource.data.length;
    const numSelected = this.selection.selected.length;
    return numSelected === numRows;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      this.rangeChanged.emit({ isSelected: false, elements: this.dataSource.data });
    } else {
      this.dataSource.data.forEach((element) => this.selection.select(element));
      this.rangeChanged.emit({ isSelected: true, elements: this.dataSource.data });
    }
  }

  manipulateSelections(event: any, element: any) {
    this.rowChanged.emit({ isSelected: event.checked, element });
    const result = event.checked
      ? this.selection.toggle(element)
      : this.selection.deselect(element);
  }

  showErrorDetail(error: any) {
    const dataDialog = {
      title: `${error.status}`,
      error,
      columns: this.modalColumns,
    };
    const dialogRef = this.dialog.open(ModalErrorsDetailsComponent, {
      width: '100%',
      height: '80vh',
      data: dataDialog,
      maxWidth: '80vw',
      panelClass: 'custom-mat-dialog',
    });

    dialogRef.afterClosed().subscribe((action: string) => {
      if (action && action === 'reprocess') {
        this.doReprocess(error);
      }
    });
  }

  doReprocess(element: any) {
    this.selection.clear();
    this.tradeReprocess.emit(element);
  }
  doBatchReprocess() {
    this.batchReprocess.emit(this.selection.selected);
    this.selection.clear();
  }

  handlePageEvent(e: PageEvent) {
    this.selection.clear();
    this.pageChanged.emit({ currentPage: e.pageIndex + 1, pageSize: e.pageSize });
  }
}
